import { Fab } from "@material-ui/core";

export default Fab;
